import {
  clearHyperDXUser,
  setHyperDXUser,
} from "@circle-react/helpers/hyperdxHelpers";
import { useEffect } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";

export const useHyperDXIdentity = () => {
  const { currentUser, currentCommunity } = usePunditUserContext();

  useEffect(() => {
    if (currentUser?.id) {
      setHyperDXUser(currentUser.id, currentCommunity?.id);
    } else {
      clearHyperDXUser();
    }
  }, [currentUser?.id, currentCommunity?.id]);
};
